import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaTruckMoving,
  FaUser,
  FaBus,
  FaCogs,
  FaTools,
  FaRegClipboard,
  FaSearch,
  FaLock,
  FaChevronRight,
  FaClock
} from "react-icons/fa";

import styles from "./Menu.module.css";

const OperacionesMenu = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const modulos = [
    {
      title: "Inbound",
      icon: <FaTruckMoving />,
      color: "linear-gradient(135deg, #6366f1, #0081cf)",
      path: "/inbound",
      desc: "Recepción, descarga y control de muestreo.",
      status: "activo",
    },
    {
      title: "Plan de muestreo",
      icon: <FaRegClipboard />,
      color: "linear-gradient(135deg, #00c6ff, #0072ff)",
      path: "/planmuestreo",
      desc: "Gestión de planes de muestreo.",
      status: "activo",
    },
    {
      title: "Personal",
      icon: <FaUser />,
      color: "linear-gradient(135deg, #10b981, #34d399)",
      desc: "Administración de turnos, cuadrillas y rendimiento de colaboradores.",
      status: "proximamente",
    },
    {
      title: "Transporte",
      icon: <FaBus />,
      color: "linear-gradient(135deg, #0ea5e9, #67e8f9)",
      desc: "Control de flota, muelles de carga y programación de despacho vehicular.",
      status: "proximamente",
    },
    {
      title: "Mantenimiento",
      icon: <FaCogs />,
      color: "linear-gradient(135deg, #f59e0b, #fbbf24)",
      desc: "Gestión proactiva de equipos, maquinaria y activos industriales.",
      status: "proximamente",
    },
    {
      title: "Servicios",
      icon: <FaTools />,
      color: "linear-gradient(135deg, #8b5cf6, #c084fc)",
      desc: "Órdenes de trabajo, servicios complementarios y tareas técnicas.",
      status: "proximamente",
    },
  ];

  const filtrados = modulos.filter((m) =>
    m.title.toLowerCase().includes(search.toLowerCase())
  );

  const abrir = (m) => {
    if (m.status !== "activo") return;
    navigate(m.path);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        <h1 className={styles.title}>Gestión de Operaciones</h1>
        {/* <p className={styles.titleDescription}>
          Optimice la cadena de suministro supervisando cada fase operativa desde la recepción hasta el despacho final.
        </p> */}
      </div>

      <div className={styles.searchContainer}>
        <div className={styles.searchBox}>
          <FaSearch />
          <input
            placeholder="Buscar módulo operativo..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.grid}>
        {filtrados.map((m, i) => (
          <div
            key={i}
            className={`${styles.card} ${m.status !== "activo" ? styles.disabled : ""
              }`}
            onClick={() => abrir(m)}
          >
            <div
              className={styles.icon}
              style={{ background: m.color }}
            >
              {m.icon}
            </div>

            <h4>{m.title}</h4>
            <p className={styles.desc}>{m.desc}</p>

            {m.status === "activo" ? (
              <div style={{ marginTop: 'auto', paddingTop: '10px', color: 'var(--secondary)', fontSize: '0.75rem', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '5px' }}>
                ACCEDER <FaChevronRight style={{ fontSize: '10px' }} />
              </div>
            ) : (
              <div className={styles.lock}>
                <FaLock /> Sin Acceso
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OperacionesMenu;
